import React from 'react'
import { Box } from '../../layout/Box'
import Input from '../../layout/Input'
import { ErrorMessage } from '../../data/ErrorMessage'

type LoginFormProps = {
  error: string
  setEmail: (e: string) => void
  setPassword: (e: string) => void
}

const LoginForm: React.FC<LoginFormProps> = ({ error, setEmail, setPassword }) => {
  return (
    <>
      <Box margin="1rem 0 0">
        <Input name="email" label="Email" onChange={setEmail} />
        <Input name="password" type="password" label="Password" onChange={setPassword} />
      </Box>

      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  )
}

export default LoginForm
